import { LoadingSpinner, ProgressBar } from '@goodneighbor/ui';
import styles from './registrationCounter.module.scss';
import { useMemo } from 'react';
import useEventRegistrationCountQuery from '@/hooks/api/events/useEventRegistrationCountQuery';
import { isErrorResponse } from '@/services/typeguards';

export default function RegistrationCounter({
  eventId,
  total,
  className
}: {
  eventId: string;
  total: number;
  className?: string;
}) {
  const { data, isLoading, error } = useEventRegistrationCountQuery({
    id: eventId || ''
  });

  const registrationData = useMemo(() => {
    if (!data || isErrorResponse(data)) {
      return null;
    }
    return data.data;
  }, [data]);

  const { registrationCount = 0 } = registrationData || {};

  const progress = useMemo(() => {
    if (total === 0) return 0;
    return (registrationCount / total) * 100;
  }, [registrationCount, total]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div>Error loading registration data.</div>;
  }

  return (
    <div>
      <ProgressBar className={className} value={progress} />
      <div className={styles.registrationStats}>
        <div>{registrationCount} spots filled</div>
        <div className={styles.registrationStatsAvailable}>
          {total - registrationCount} spots open
        </div>
      </div>
    </div>
  );
}
